import { NodeInterface, NodeType } from "@swivl-mono/types";
import { Checkbox, Dropdown, RadioButtons, SelectableOption } from "@swivl-mono/ui";
import { TagInput, TagInputType } from "../../../../Components/TagInput/TagInput";
import VarsModel from "../../../../Models/Variables/VarsModel.Model";

import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";
import { RandomId } from "@swivl-mono/helpers";


const Analytics = {
  Type: "analytics",
  Empty: function () {
    return {
      "id": RandomId(6),
      "type": NodeType.Analytics,
      "platform": "GA",
      "event": "swivl-event",
      "action": "Swivl-Action",
      "title": "Analytics (GA)",
      "subtitle": "Swivl Category\nSwivl Action\nSwivl Label",
      "category": "Swivl Category",
      "label": "Swivl Label",
      "onCompleteGoto": null
    }
  },

  PlumbData: function (node: NodeInterface) {
    //     gtag('event', command.action, {
    //   'event_category': command.category,
    //   'event_label': command.label
    // });
    const text = (node.platform && (node.platform === "GTM" || node.platform === "Amplitude")) ? node.event : node.action + "\n" + node.category + "\n" + node.label;

    const body = VarsModel.replaceVariableNameInString(text, "*", "*");

    return TabNodeLayoutData({
      node: node,
      label: "Analytics",
      title: node.platform,
      body: body,
      baseWidth: 160,
      bodyHeight: 55,
      tabs: [{ id: "onCompleteGoto", source: "onCompleteGoto", target: node.onCompleteGoto, }]
    });
  },

  InspectorPanel: class AnalyticsInspectorPanel extends NodePanel {
    render() {
      const options: SelectableOption[] = [
        { value: "GA", label: "Analytics.js (GA)" },
        { value: "GTAG", label: "G Tag (GTAG)" },
        { value: "GTM", label: "Tag Manager (GTM)" },
        { value: "CustomDimension", label: "Custom Dimension" },
        { value: "Amplitude", label: "Amplitude" }
      ];

      var content;
      if (this.props.node.platform && (this.props.node.platform === "GTM" || this.props.node.platform === "Amplitude")) {
        content = <div>
          <label>Event Name</label>
          <TagInput
            type={TagInputType.SingleLine}
            value={this.props.node.event}
            onChange={this.onChange}
            name="event"
            placeholder="Event..."
          />
        </div>;

      } else if (this.props.node.platform && (this.props.node.platform === "CustomDimension")) {
        content = <div key="cd">
          <label>Type</label>
          <Dropdown
            options={[{ value: "GA", label: "Analytics.js (GA)" },
            { value: "GTAG", label: "G Tag (GTAG)" }]}
            value={this.props.node.dimensionType} onSet={(op) => {
              this.onChangeSwitch("dimensionType", op)
            }} name="dimensionType" />

          {this.props.node.dimensionType === "GTAG" && <>
            <label>Tracking Id</label>
            <TagInput
              type={TagInputType.SingleLine}
              value={this.props.node.trackingId}
              onChange={this.onChange}
              name="trackingId"
              placeholder="Tracking id..."
            />

            <label>Dimension Index</label>
            <TagInput
              type={TagInputType.SingleLine}
              value={this.props.node.dimensionIndex}
              onChange={this.onChange}
              name="dimensionIndex"
              placeholder="Dimension index..."
            />
          </>
          }

          <label>Dimension Name</label>
          <TagInput
            type={TagInputType.SingleLine}
            value={this.props.node.dimensionName}
            onChange={this.onChange}
            name="dimensionName"
            placeholder="Dimension name..."
          />

          {this.props.node.dimensionType !== "GTAG" && <>
            <label>Dimension Value</label>
            <TagInput
              type={TagInputType.SingleLine}
              value={this.props.node.dimensionValue}
              onChange={this.onChange}
              name="dimensionValue"
              placeholder="Dimension value..."
            />
          </>}

        </div>
      } else {
        content = <div>
          <label>Category</label>
          <TagInput
            type={TagInputType.SingleLine}
            value={this.props.node.category}
            onChange={this.onChange}
            name="category"
            placeholder="Category..."
          />

          <label>Action</label>
          <TagInput
            type={TagInputType.SingleLine}
            value={this.props.node.action}
            onChange={this.onChange}
            name="action"
            placeholder="Action..."
          />

          <label>Label</label>
          <TagInput
            type={TagInputType.SingleLine}
            value={this.props.node.label}
            onChange={this.onChange}
            name="label"
            placeholder="Label..."
          />
          {(this.props.node.platform === "GTAG") && <>
            <Checkbox
              checked={this.props.node.sendDimension}
              name={"sendDimension"}
              onCheckedChange={(checked) => this.onChangeSwitch("sendDimension", checked)}
              label="Send custom dimension"
            />
            {this.props.node.sendDimension && (
              <>
                <label>Dimension Name</label>
                <TagInput
                  type={TagInputType.SingleLine}
                  value={this.props.node.dimensionName}
                  onChange={this.onChange}
                  name="dimensionName"
                  placeholder="Dimension name..."
                />

                <label>Dimension Value</label>
                <TagInput
                  type={TagInputType.SingleLine}
                  value={this.props.node.dimensionValue}
                  onChange={this.onChange}
                  name="dimensionValue"
                  placeholder="Dimension value..."
                />
              </>
            )}
          </>
          }
        </div>;
      }

      return (
        <div>
          <div className="panel analytics_panel">
            <InspectorNodeHeader title="Analytics" />
            <label>Analytics Platform</label>
            <RadioButtons options={options} name="platform" value={this.props.node.platform} onChange={this.onChangeUpdateAndRedraw} />
            {content}
            <div className="variableInfo">Note: You must install Google Analytics (or GTM, or Amplitude) on your page in order to use analytics events.</div>
          </div>
          <InspectorFooter deleteNode={this.deleteNode} node={this.props.node} />
        </div>
      );
    }
  }
}
export default Analytics;
